import { ApiContextType } from '../api-context';
import {
    FetchRequest,
    FetchDevicesResponse
} from '../typings';
export const fetchDevices = (api: ApiContextType, request: FetchRequest): Promise<FetchDevicesResponse> => {
    return api.post(`/devices`, request)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const activateDevice = (api: ApiContextType, id: string): Promise<void> => {
    return api.post(`/device/${id}/activate`)
        .then(res => {
            if (res.status === 200 || res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};

export const deactivateDevice = (api: ApiContextType, id: string): Promise<void> => {
    return api.post(`/device/${id}/deactivate`)
        .then(res => {
            if (res.status === 200 || res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};

export const deleteDevice = (api: ApiContextType, id: string): Promise<void> => {
    return api.del(`/device/${id}`)
        .then(res => {
            if (res.status === 200 || res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};


